import { PieChart, PieChartProps } from '@makyoapp/makyo-tw-ui'

export type CompChartPieProps = PieChartProps

export const CompChartPieCore = PieChart
